import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  imageWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  backgroundImage: {
    flexShrink: 0,
    minHeight: '100%',
    width: '100%',
    objectFit: 'cover',
    borderRadius: theme.spacing(.5),
    marginTop: theme.spacing(2.5),
}
}))

export default useStyles;
